import {
    CONTACT_LIST_REQUEST,
    CONTACT_LIST_FAIL,
    CONTACT_LIST_RESET,
    CONTACT_LIST_SUCCESS,
    CONTACT_DETAIL_REQUEST,
    CONTACT_DETAIL_SUCCESS,
    CONTACT_DETAIL_FAIL,
    CONTACT_DETAIL_RESET
} from '../constants/contactConstants'
import api from '../core/api'

export const listContact = (searchKeyword) => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTACT_LIST_REQUEST })

        const { data } = await api.get(
            "/contacts/getContactEmail/" + searchKeyword
        )

        var dt = data.Result;

        if (typeof (dt) == 'string') {
            dispatch({
                type: CONTACT_LIST_FAIL,
                payload: dt
            })
        } else {
            dispatch({
                type: CONTACT_LIST_SUCCESS,
                payload: data.Result
            })
        }
    }
    catch (error) {
        dispatch({
            type: CONTACT_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const getDetailsContacts = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTACT_DETAIL_REQUEST })

        const { data } = await api.get(
            "/contacts/getContact/" + id,
        )

        dispatch({
            type: CONTACT_DETAIL_SUCCESS,
            payload: data.Result[0]
        })
    }
    catch (error) {
        dispatch({
            type: CONTACT_DETAIL_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const getActivitiesContacts = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: CONTACT_DETAIL_REQUEST })

        const { data } = await api.get(
            "/contacts/getContact/" + id,
        )

        dispatch({
            type: CONTACT_DETAIL_SUCCESS,
            payload: data.Result[0]
        })
    }
    catch (error) {
        dispatch({
            type: CONTACT_DETAIL_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}